import { FC, Dispatch, SetStateAction } from 'react'
import { Box } from '@mui/material'

/* Utils */
import { CategoryActivityItem, IChartData, IFramework } from '../../../../models'

/* Components */
import PerformanceScore from './PerformanceScore'
import InsightsWidget from './InsightsWidget'
import OverallPerformanceScore from './OverallPerformanceScore/OverallPerformanceScore'

interface Props {
  performanceScore: number
  performanceLastMonthChange: number | null
  chartLoading: boolean
  initialLoad: boolean
  chartData: IChartData[]
  noCategories: boolean
  handleCategoryClick: (category: string) => void
  lastUpdatePerformance: string
  unreadInsightsCount: number
  insightsCountLoading: boolean
  insightsData: any
  setHoveredCard: Dispatch<SetStateAction<string>>
  customFramework: IFramework | null
  categories: CategoryActivityItem[]
}

const DashboardHero: FC<Props> = ({
  performanceScore,
  performanceLastMonthChange,
  chartLoading,
  initialLoad,
  chartData,
  noCategories,
  handleCategoryClick,
  lastUpdatePerformance,
  unreadInsightsCount,
  insightsCountLoading,
  insightsData,
  setHoveredCard,
  customFramework,
  categories
}) => {
  return (
    <>
      <Box className="performance-score-section">
        <OverallPerformanceScore
          performanceScore={performanceScore}
          lastMonthChange={performanceLastMonthChange}
          categories={categories}
        />
        <PerformanceScore
          chartLoading={chartLoading}
          initialLoad={initialLoad}
          chartData={chartData}
          isEmpty={false}
          handleCategoryClick={handleCategoryClick}
          noCategories={noCategories}
          lastUpdatePerformance={lastUpdatePerformance}
          setHoveredCard={setHoveredCard}
          customFramework={customFramework}
        />
        <InsightsWidget
          unreadInsightsCount={unreadInsightsCount}
          insightsCountLoading={insightsCountLoading}
          insightsData={insightsData}
        />
      </Box>
    </>
  )
}

export default DashboardHero
